"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockDeferLiquidityCheckCallerFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "a",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tectonicCoreAddress",
                type: "address",
            },
        ],
        name: "callTectonicCore",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "onDeferredLiquidityCheck",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x60806040526000805534801561001457600080fd5b506102a6806100246000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c80630dbe671f1461004657806312fd976814610061578063a15db5c514610076575b600080fd5b61004f60005481565b60405190815260200160405180910390f35b61007461006f36600461014c565b61008d565b005b61007461008436600461017a565b50506001600055565b6040805180820182526006815265737472696e6760d01b602082015290516001600160a01b038316906389b7b7a69030906100cc90859060240161025d565b60408051601f198184030181529181526020820180516001600160e01b031663a15db5c560e01b1790525160e084901b6001600160e01b0319168152610116929190600401610231565b600060405180830381600087803b15801561013057600080fd5b505af1158015610144573d6000803e3d6000fd5b505050505050565b60006020828403121561015d578081fd5b81356001600160a01b0381168114610173578182fd5b9392505050565b6000806020838503121561018c578081fd5b82356001600160401b03808211156101a2578283fd5b818501915085601f8301126101b5578283fd5b8135818111156101c3578384fd5b8660208285010111156101d4578384fd5b60209290920196919550909350505050565b60008151808452815b8181101561020b576020818501810151868301820152016101ef565b8181111561021c5782602083870101525b50601f01601f19169290920160200192915050565b6001600160a01b0383168152604060208201819052600090610255908301846101e6565b949350505050565b60006020825261017360208301846101e656fea2646970667358221220f2a930c71e2a93dacce66657d625ffbdea98398ebf90d8d781388f31aa8a77cd64736f6c63430008030033";
class MockDeferLiquidityCheckCallerFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MockDeferLiquidityCheckCallerFactory = MockDeferLiquidityCheckCallerFactory;
MockDeferLiquidityCheckCallerFactory.bytecode = _bytecode;
MockDeferLiquidityCheckCallerFactory.abi = _abi;
//# sourceMappingURL=MockDeferLiquidityCheckCallerFactory.js.map